import alt from "../alt";

class PassActions {
  constructor() {
    this.generateActions(
      "updatePasses",
      "fetchAll",
      "fetchOne",
      "fetchFailed",
      "fetchPassTypes",
      "updatePassTypes",
      "editFailed",
      "resendPassTransfer",
      "cancelPassTransfer"
    );
  }

  updatePass(id, pass) {
    return { id, pass };
  }

  editPass(id, values) {
    return { id, values };
  }

  transferPass(id, destinationEmail) {
    return { id, destinationEmail };
  }

  acceptPassTransfer(id, token) {
    return { id, token };
  }

  sendGiftPass(id, opts) {
    return { id, opts };
  }
}

export default alt.createActions(PassActions);



// WEBPACK FOOTER //
// ./src/app/actions/PassActions.js